import {ChangeEvent, useContext, useState} from "react";
import UserContext, {UserContextType} from "../../store/UserContext";
import {
    BannerState,
    PBanner,
    PButton,
    PDivider,
    PHeading,
    PSpinner,
    PText
} from "@porsche-design-system/components-react";
import {uploadVipReservations} from "../../api/LimitationNumberService";
import {useModelState} from "../../store/ModelContext";
import {UploadResponse} from "../../store/response";
import { Grid } from "@react-css/grid";

interface Banner {
    state: BannerState;
    title: string;
    description: string;
    duration?: number;
}

function VipReservationTab() {
    const {lenaAuthToken} = useContext<UserContextType>(UserContext);
    const modelContextState = useModelState();
    const [fileName, setFilename] = useState<string>("");
    const [uploadResult, setUploadResult] = useState<Array<UploadResponse>>([])
    const [isBannerShow, setBannerShow] = useState(false);
    const [bannerInfo, setBannerInfo] = useState<Banner>({
        state: "info",
        title: "LENA Notification",
        description: "",
        duration: 3000
    });
    const [showSubmitFileUploadBanner, setShowSubmitFileUploadBanner] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);

    function showBanner(message: string, resultState : BannerState) {
        let bannerInfo: Banner = {
            state: resultState,
            title: "LENA Notification",
            description: message,
            duration: 6000
        };
        setBannerInfo(bannerInfo);
        setBannerShow(true);

        const timer = setTimeout(() => {
            setBannerShow(false);
        }, bannerInfo.duration);
        return () => clearTimeout(timer);
    }

    function submitFile() {
        setShowSubmitFileUploadBanner(false);
        setLoading(true);
        const input: HTMLInputElement = document.querySelector('input[type="file"]');
        let reader = new FileReader();
        reader.readAsDataURL(input.files[0]);
        reader.onload = function () {
            uploadVipReservations(lenaAuthToken, reader.result, fileName, modelContextState.globalOrderType)
                .then((response) => {
                    setFilename("");
                    setLoading(false);
                    setUploadResult(response);
                    input.value = "";

                    if (response.length === 0) {
                        showBanner("All reservations are saved successfully.", "info");
                    }
                })
                .catch((error) => {
                    showBanner(error.message, "error");
                    setLoading(false);
                });
        };
        reader.onerror = function (error: ProgressEvent<FileReader>) {
            console.log(error);
            showBanner("Error during file upload: " + error, "error");
        };
    }

    function handleSubmitFileUpload() {
        if (modelContextState.globalOrderType === "") {
            const input: HTMLInputElement = document.querySelector('input[type="file"]');
            showBanner("Please select a model.", "error");
            input.value = "";
        } else {
            setShowSubmitFileUploadBanner(false);
            setTimeout(() => {
                setShowSubmitFileUploadBanner(true);
            }, 100);
        }
    }

    function handleCancelSubmitFileUpload() {
        setShowSubmitFileUploadBanner(false);
        setFilename("");
        const input: HTMLInputElement = document.querySelector('input[type="file"]');
        input.value = "";
    }

    function uploadFile(e: ChangeEvent<HTMLInputElement>) {
        const fileName = e.target.files[0].name;
        if (fileName.indexOf(".csv") > 0) {
            setFilename(fileName);
        } else {
            showBanner("The uploaded file is not a csv file.", "error");
        }
    }

    return (
        <div>
            {isBannerShow && (
                <PBanner  dismissButton={false} state={bannerInfo.state} className="info-banner"  autoFocus={false} inert={false}
                         open={true} heading={bannerInfo.title}>
                    <span slot="description">{bannerInfo.description}</span>
                </PBanner>
            )}
            {showSubmitFileUploadBanner && (
                <PBanner
                    dismissButton={true}
                    onDismiss={() => handleCancelSubmitFileUpload()}
                    className="submit-file-upload-confirm-banner"  autoFocus={false} inert={false} open={true}
                    heading="After the upload existing reservations will be lost or overwritten by new one. Do you want to continue?">
                    <div slot="description" className="submit-file-upload-confirm-banner__description">
                        <PButton className="confirm-button" variant="secondary" onClick={() => handleCancelSubmitFileUpload()}  autoFocus={false} inert={false}>
                            Cancel
                        </PButton>
                        <PButton variant="primary" className="confirm-button" onClick={() => submitFile()}  autoFocus={false} inert={false}>
                            Ok
                        </PButton>
                    </div>
                </PBanner>
            )}
            <Grid >
                <Grid.Item >
                    <input
                        type="file"
                        className={"inputFileUpload"}
                        id="inputFileUpload"
                        onChange={(e) => {
                            uploadFile(e);
                        }}
                    />
                    {fileName !== "" && <PText  autoFocus={false} inert={false}>Uploaded file: {fileName}</PText>}
                </Grid.Item>
                <Grid.Item justifySelfEnd={true}>
                    <PButton variant={"primary"} onClick={() => handleSubmitFileUpload()}  autoFocus={false} inert={false}>
                        Submit
                    </PButton>
                </Grid.Item>
                <Grid.Item justifySelfStretch={true}>
                    {loading && <PSpinner className={"spinner"} size={{base: "small", l: "medium"}}  autoFocus={false} inert={true}/>}
                    {!loading && uploadResult.length > 0 && <div className={"message-field-wrapper"}>
                        <PDivider className="divider"  autoFocus={false} inert={true}></PDivider>
                        <PHeading className={"headline"} tag="h5" size={"small"} autoFocus={false} inert={true}>
                            Upload Messages
                        </PHeading>
                        <div className={"message-field"}>
                            {uploadResult.map((result, index) => {
                                    return (<PText className={"message-text"} key={index + "upload"}
                                                    autoFocus={false} inert={true}>{result.message}</PText>)
                                }
                            )}
                        </div>
                    </div>
                    }
                </Grid.Item>
            </Grid>
        </div>
    );
}

export default VipReservationTab;
